export const createOrganization = `
    mutation createOrganization($input: CreateOrganizationInput!) {
        createOrganization(input:$input) {
            id
            name
            adminAccountId
            description
            email
            url
            phone
            createdByUsername
            created
    }
}`;

export const updateOrganization = `
    mutation updateOrganization($input: UpdateOrganizationInput!) {
        updateOrganization(input:$input){
            id
            name
            adminAccountId
            description
            email
            url
            phone
            createdByUsername
            created
            updated
        }
}`;

export const deleteOrganization = `
    mutation deleteOrganization($input: DeleteOrganizationInput!) {
        deleteOrganization(input:$input) {
            id
        }
}`;
